export const initFaqAccordion = () => {
  const accordionItems = document.querySelectorAll('.faq__item');

  function updateFocusableState(container, isOpen) {
    if (!container) return;
    const focusables = container.querySelectorAll(
      'a, button, input, textarea, select, [tabindex]',
    );
    focusables.forEach((el) => {
      if (isOpen) {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', '-1');
      }
    });
  }

  accordionItems?.forEach((item) => {
    const button = item.querySelector('.faq__accordionBtn');
    const content = item.querySelector('[data-accordion-text]');

    const isInitiallyOpen = item.classList.contains('is-open');
    updateFocusableState(content, isInitiallyOpen);

    button.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');
      const section = item.closest('.faq');

      section.querySelectorAll('.faq__item.is-open').forEach((openItem) => {
        openItem.classList.remove('is-open');
        updateFocusableState(
          openItem.querySelector('[data-accordion-text]'),
          false,
        );
      });

      if (!isOpen) {
        item.classList.add('is-open');
        updateFocusableState(content, true);
      }
    });
  });
};
